// extracted by mini-css-extract-plugin
export default {"table":"StudnetInfo_table__2F0tG"};